
    <div
      *ngIf="! standalone"
      class="form-group"
    >
      <div class="d-flex d-flex-gap">
        <fieldmagic-text
          purpose="input"
          [content]="label"
          [withRequiredMarker]="withRequiredMarker"
        >
        </fieldmagic-text>
      </div>
      <ng-container *ngTemplateOutlet="input"></ng-container>
    </div>

    <ng-container
      *ngIf="standalone"
      [ngTemplateOutlet]="input"
    >
    </ng-container>

    <ng-template #input>
      <div class="input-group">
        <input
          [(ngModel)]="value"
          [value]="value"
          type="text"
          [attr.id]="id"
          class="form-control fieldmagic-datetime-input"
          [owlDateTime]="calendar"
          [placeholder]="placeholder"
          (ngModelChange)="onChanged($event)"
          readonly
          [disabled]="disabled$ | async"
          [matTooltip]="tooltip$ | async | translate"
        />

        <fieldmagic-icon
          *ngIf="clearable && (value | filled)"
          icon="times"
          purpose="clicking"
          class="fieldmagic-datetime-clear-button"
          (click)="onClear()"
        >
        </fieldmagic-icon>

        <button
          [matTooltip]="(btnTooltip$ | async) | translate"
          class="fieldmagic-datetime-button"
          [owlDateTimeTrigger]="calendar"
          [disabled]="disabled$ | async"
        >
          <div class="d-flex justify-content-center">
            <fieldmagic-icon
              icon="calendar"
            >
            </fieldmagic-icon>
          </div>
        </button>

        <owl-date-time
          #calendar
          [pickerType]="type$ | async"
        >
        </owl-date-time>
      </div>

      <fieldmagic-input-errors
        *ngIf="errors | filled"
        [errors]="errors"
      ></fieldmagic-input-errors>
    </ng-template>
  